export const Layouts = {
    list: 'list',
    grid: 'grid'
}